import { render } from "./LessonList.vue?vue&type=template&id=2c9c9aa2&scoped=true"
import script from "./LessonList.vue?vue&type=script&lang=js"
export * from "./LessonList.vue?vue&type=script&lang=js"

import "./LessonList.vue?vue&type=style&index=0&id=2c9c9aa2&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9c9aa2"]])

export default __exports__